import styled from "@emotion/styled";
import { LoadingContainer } from "@ui/components/common/loading-container";
import React, { CSSProperties, useMemo } from "react";

export enum LoadingSize {
	FullScreen = "FullScreen",
	FullSpace = "FullSpace",
}

interface LoadingEmptyProps {
	size?: LoadingSize;
}

export const LoadingEmptyScreen: React.FC<LoadingEmptyProps> = ({ size } = { size: LoadingSize.FullSpace }) => {
	const loaderStyle: CSSProperties = useMemo(() => {
		switch (size) {
			case LoadingSize.FullSpace:
				return { flex: 1 };
			case LoadingSize.FullScreen:
			default:
				return {
					height: "100vh",
					width: "100vw",
				};
		}
	}, [size]);

	return (
		<Container style={loaderStyle}>
			<LoadingContainer />
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
